export const getWeekdayName = (
  dateInput: string | number | Date,
  locale = "en-US",
  format: "long" | "short" | "narrow" = "long"
) => {
  const dt = dateInput instanceof Date ? dateInput : new Date(dateInput);
  if (Number.isNaN(dt.getTime())) return "";
  return dt.toLocaleDateString(locale, { weekday: format });
};
